export default __webpack_public_path__ + "media/magento.f8f87882.png";